const media = {
    tablet: '768px',
    desktop: '1125px',
    mobile: '480px',
    mini: '375px',
};

export default media;
